import { Expose } from 'class-transformer';
import { Prize } from '../models/Prize';
import { ResponseBase } from './base/ResponseBase';

export class PrizeResponse extends ResponseBase {
        @Expose({ name: 'results' })
        prize?: Prize;
}